import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Container, Segment, Table, Dimmer, Loader } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { getDeviceLogsAction } from 'state/business/actions';
import { SemanticToastContainer } from 'react-semantic-toasts';

const mapStateToPropsDeviceLogs = ({ business }) => ({
  deviceLogs: business.deviceLogs,
  loadingOutlets: business.loadingOutlets,
  allBusiness: business.allBusiness,
});

const DeviceLogs = connect(mapStateToPropsDeviceLogs)(props => {
  const { dispatch, deviceLogs, allBusiness, loadingOutlets } = props;
  const businessId = allBusiness.data[allBusiness.activeIndex].id;

  useEffect(() => {
    dispatch(getDeviceLogsAction({ businessId }));
  }, [businessId, dispatch]);

  return (
    <Container
      style={{ overflowY: 'scroll', maxHeight: '50vh', padding: '1vh' }}
    >
      <SemanticToastContainer />
      <Segment style={{ padding: '0px' }}>
        <Dimmer active={loadingOutlets}>
          <Loader size="massive">Loading</Loader>
        </Dimmer>
        <Table celled selectable style={{ margin: '0px' }}>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Devices</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {deviceLogs.data && deviceLogs.data.length > 0 ? (
              deviceLogs.data.map(deviceLog => {
                return (
                  <Table.Row key={deviceLog.id}>
                    <Table.Cell key={deviceLog.app_version}>
                      {deviceLog.app_version}
                    </Table.Cell>
                  </Table.Row>
                );
              })
            ) : (
              <>
                <Table.Row>
                  <Table.Cell>No Devices</Table.Cell>
                </Table.Row>
              </>
            )}
          </Table.Body>
        </Table>
      </Segment>
    </Container>
  );
});

DeviceLogs.propTypes = {
  dispatch: PropTypes.func.isRequired,
  deviceLogs: PropTypes.object.isRequired,
  loadingOutlets: PropTypes.bool.isRequired,
  allBusiness: PropTypes.object.isRequired,
};

export default DeviceLogs;
